<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import { ref } from 'vue'
import './BlogPost.sass'
import type { PostOrPage } from '@tryghost/content-api'
import { IconChevronRightSmall } from '@cypress-design/vue-icon'
import EditPostButton from '@/components/pages/blog/vue/EditPostButton/EditPostButton.vue'

defineProps<{
  blogPost: PostOrPage
  backHref: string
}>()

const $blogContent = ref<HTMLDivElement>()
</script>

<template>
  <div v-if="blogPost" class="mx-auto max-w-[800px]">
    <div class="flex items-center justify-between">
      <p class="flex items-center gap-[4px] font-medium">
        <span v-if="backHref" class="flex items-center gap-[4px]">
          <a :href="backHref" class="text-gray-600 hover:text-indigo-500">Blog</a>
          <IconChevronRightSmall stroke-color="gray-300" />
        </span>
        <span v-if="blogPost.primary_tag" class="flex items-center gap-[4px]">
          <a :href="'/blog/tag/' + blogPost.primary_tag?.slug" class="text-gray-600 hover:text-indigo-500">
            {{ blogPost.primary_tag?.name }}
          </a>
          <IconChevronRightSmall stroke-color="gray-300" />
        </span>
      </p>
      <EditPostButton :post-id="blogPost.id" />
    </div>
    <h1 class="mb-[12px] mt-[20px] pb-[0] font-primary text-[32px] font-semibold leading-[44px]">
      {{ blogPost.title }}
    </h1>
    <div class="mb-[20px] flex gap-[12px] text-gray-400">
      <p v-if="blogPost.published_at" class="text-gray-700">
        {{
          new Date(blogPost.published_at).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        }}
      </p>
      <p>•</p>
      <p v-if="blogPost.authors?.length" class="text-gray-700">
        By {{ blogPost.authors.map((a) => a.name).join(' & ') }}
      </p>
    </div>
    <img
      v-if="blogPost.feature_image"
      :src="blogPost.feature_image"
      :alt="blogPost.feature_image_alt ?? ''"
      class="mb-[24px] rounded-md"
    />

    <div ref="$blogContent" class="blog-content" data-cy="blog-post-content" v-html="blogPost.html" />
  </div>
</template>
